<mh-alerts-wrapper>

  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
          [currentDates]="currentDates"
          [currentFilter]="currentFilterDate"
          (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <ng-container *ngIf="fidelityPermisions.includes('interchain_prestay_trends_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" (chainChanged)="setChain($event)" [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
      </ng-container>
    </div>
  </section>
  <mh-box-element [title]="('inter-chain.prestay.trends.title' | translate )" *ngIf="fidelityPermisions.includes('interchain_prestay_trends_result')">
    <div class="tw-flex tw-justify-end">
      <widget-modal-faq
        [faqs]="faqs"
        [prefixTranslate]="prefixTranslateFAQ"
      ></widget-modal-faq>
    </div>
    <mh-chain-prestay-trends [currentDates]="currentDates" [chain]="chainFilter" (isReady)="dataIsReady($event)"></mh-chain-prestay-trends>
  </mh-box-element>

</mh-alerts-wrapper>
